
export const API_URL = "https://rescuredemo2-c92c7df2a943.herokuapp.com/api/";
export const API_BASE = "https://rescuredemo2-c92c7df2a943.herokuapp.com/";
export const SESSION_COOKIE = "usrYRxDemoLocLivMiSTRRX1000";


/*
export const API_URL = "http://localhost:1023/api/";
export const SESSION_COOKIE = "usrYRxDemoLocLivMiSRXLocal";

*/

export const FRONT_EMAIL = "https://resqscripts.co.za/emailers/emailsend.php";
export const SMS_SEND = "https://cjmarketing.co/bulksms/index.php?";
export const SMALL_PROCESSING = "https://api.picnick.co.za/assets/smallprocess.gif";
export const BLUE_PROCESSING = "http://cjmarketing.co/image_directory/blue-load.gif";
export const IMAGE_PROFILE = "https://newclient.cjdsa.co.za/images/base/profile.jpg";